module.exports = function getResource(label, vars=[]) {
    const resources = {
        bopisTitle: `Achetez en ligne et ramassez en magasin (${vars[0]})`,
        shippingTitle: `Panier d’expédition et de livraison (${vars[0]})`,
        basketSwitchBOPIS: 'Consultez votre panier d’articles « Achetez en ligne, ramassez en magasin »',
        basketSwitchShipping: 'Consultez votre panier d’expédition et de livraison',
        sddRougePromoBannerTitle: 'Want your items today? ',
        sddRougePromoBannerMessage: `Rouge members can try Free Same-Day Delivery on ${vars[0]}+ orders! Check availability by tapping the "Get It Sooner" button.`
    };

    return resources[label];
};
